import { useGetIdentity } from "ra-core";
import { matchPath } from "react-router";

/**
 * Perfis de leitura com data de corte (migration 184): `leitura_master` e
 * `leitura_vendedor`.
 *
 * NADA AQUI É A TRAVA. O banco nega leitura direta de tabela a esses perfis,
 * barra toda escrita e só entrega dado pelas views `leitura_*`, já recortadas e
 * sem telefone. Este arquivo existe para a tela funcionar em cima disso: pedir
 * a view no lugar da tabela, e não oferecer tela nem botão que o banco recusa.
 */

export type PerfilLeitura = "master" | "vendedor";

const ROTAS: Record<PerfilLeitura, string[]> = {
  master: ["/vendas", "/vendas/:id", "/inadimplentes", "/cancelamentos"],
  vendedor: [
    "/contacts",
    "/contacts/:id/show",
    "/clients",
    "/clients/:id/show",
    "/vendas",
    "/vendas/:id",
    "/inadimplentes",
  ],
};

export const ROTA_INICIAL_LEITURA = "/vendas";

export const rotaPermitidaLeitura = (perfil: PerfilLeitura, pathname: string) =>
  ROTAS[perfil].some((padrao) => matchPath(padrao, pathname) !== null);

/**
 * Tabelas que os perfis de leitura NÃO leem direto e o nome da view que as
 * substitui. As views têm as mesmas colunas, então a tela não percebe a troca.
 * Tabela fora desta lista segue o nome original e o banco decide (para eles,
 * quase sempre zero linhas).
 */
const TABELAS_COM_VIEW_DE_LEITURA = new Set([
  "servopa_vendas",
  "servopa_vendas_with_details",
  "users",
  "contacts",
  "contacts_summary",
  "contacts_lance_summary",
  "servopa_inadimplentes",
  "servopa_inadimplentes_current",
  "servopa_lances",
  "servopa_vendas_daily_snapshot",
]);

// Estado de módulo porque quem consulta (cliente Supabase e dataProvider) não
// é componente React. Definido pelo authProvider ao montar a identidade.
let perfilAtual: PerfilLeitura | null = null;

export const definirPerfilLeitura = (perfil: PerfilLeitura | null) => {
  perfilAtual = perfil;
};

export const fonteParaLeitura = (tabela: string, perfil: PerfilLeitura | null = perfilAtual) =>
  perfil && TABELAS_COM_VIEW_DE_LEITURA.has(tabela) ? `leitura_${tabela}` : tabela;

export const perfilLeituraDoPapel = (codigos: string[]): PerfilLeitura | null =>
  codigos.includes("leitura_master")
    ? "master"
    : codigos.includes("leitura_vendedor")
      ? "vendedor"
      : null;

export const useSomenteLeitura = () => {
  const { identity, isPending } = useGetIdentity();
  const perfil = (identity?.perfil_leitura ?? null) as PerfilLeitura | null;
  return { perfil, somenteLeitura: perfil !== null, isPending };
};
